import { useEffect, useRef } from 'react';
import { useTrackTitle } from "../useTrackTitle";
var DEFAULT_INTERVAL = 1500;
var DEFAULT_NOTIFICATION_TITLE = 'Новое сообщение';
var getFavicons = function getFavicons() {
  var _document;
  return (_document = document) === null || _document === void 0 ? void 0 : _document.querySelectorAll("link[rel~='icon']");
};
export var useDynamicTab = function useDynamicTab(_ref) {
  var _document2;
  var isActive = _ref.isActive,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? DEFAULT_NOTIFICATION_TITLE : _ref$title,
    _ref$interval = _ref.interval,
    interval = _ref$interval === void 0 ? DEFAULT_INTERVAL : _ref$interval,
    count = _ref.count,
    favicon = _ref.favicon;
  var originalFaviconRef = useRef([]);
  var favicons = useRef([]);
  var originalTitleRef = useRef((_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.title);
  var titleRef = useRef(title);
  var changeFavicon = function changeFavicon(isOriginal) {
    favicons.current.forEach(function (_ref2) {
      var originalLink = _ref2.originalLink,
        element = _ref2.element;
      var link = isOriginal ? originalLink : favicon !== null && favicon !== void 0 ? favicon : originalLink;
      element.href = isOriginal ? originalLink : link;
    });
  };
  useTrackTitle(title, function (value) {
    originalTitleRef.current = value;
  });
  useEffect(function () {
    titleRef.current = "".concat(count || '', " ").concat(title).trim();
  }, [count, title]);
  useEffect(function () {
    var icons = [];
    getFavicons().forEach(function (element) {
      icons.push({
        element: element,
        originalLink: element.href
      });
    });
    favicons.current = icons;
  }, []);
  useEffect(function () {
    // Если true то применяем вид для оповещения

    if (!isActive) {
      return function () {};
    }
    // Применяем оригинальную иконку или нет
    var flag = false;
    var faviconLink = originalFaviconRef.current;
    var originalTitle = originalTitleRef.current;
    var timer = setInterval(function () {
      // Используем рефки так как в процессе работы могут поменяться
      if (originalFaviconRef.current && favicon) {
        changeFavicon(!flag);
      }
      document.title = flag ? titleRef.current : originalTitleRef.current;
      flag = !flag;
    }, interval);
    return function () {
      clearInterval(timer);
      // Если больше не нужно оповещение возвращем к исходным настройкам
      if (faviconLink) {
        changeFavicon(true);
      }
      document.title = originalTitle;
    };
  }, [isActive]);
};